module.exports = __webpack_public_path__ + "static/media/img1.a2ddb548.png";